
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.402","height":"20.397","viewBox":"0 0 20.402 20.397"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 147414","d":"M10.203 4.969a5.221 5.221 0 00-5.23 5.23 5.221 5.221 0 005.23 5.229 5.221 5.221 0 005.23-5.229 5.221 5.221 0 00-5.23-5.23zm0 8.629a3.406 3.406 0 01-3.4-3.4 3.4 3.4 0 013.4-3.4 3.4 3.4 0 013.4 3.4 3.406 3.406 0 01-3.4 3.4zm6.663-8.841a1.22 1.22 0 00-1.22-1.22 1.22 1.22 0 00-1.22 1.22 1.217 1.217 0 001.22 1.22 1.217 1.217 0 001.22-1.22zm3.464 1.238a6.036 6.036 0 00-1.647-4.276A6.076 6.076 0 0014.409.071c-1.684-.1-6.732-.1-8.416 0a6.067 6.067 0 00-4.274 1.643A6.056 6.056 0 00.071 5.988c-.1 1.684-.1 6.731 0 8.415a6.036 6.036 0 001.648 4.275 6.084 6.084 0 004.274 1.647c1.684.1 6.732.1 8.416 0a6.037 6.037 0 004.274-1.647 6.076 6.076 0 001.648-4.274c.095-1.684.095-6.727-.001-8.411zm-2.177 10.216a3.442 3.442 0 01-1.937 1.939c-1.343.533-4.529.41-6.012.41s-4.674.118-6.012-.41a3.442 3.442 0 01-1.939-1.939c-.533-1.343-.41-4.529-.41-6.012s-.118-4.674.41-6.012a3.442 3.442 0 011.938-1.94c1.343-.533 4.529-.41 6.012-.41s4.674-.118 6.012.41a3.442 3.442 0 011.938 1.939c.533 1.343.41 4.529.41 6.012s.124 4.675-.41 6.013z","fill":"#245389"}})])
          )
        }
      }
    